import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Select,
  MenuItem,
} from "@mui/material";
import axiosInstance from "../api/axiosInstance";

const REPORT_CATEGORIES = [
  "Spam",
  "Harassment",
  "Misinformation",
  "Hate Speech",
  "Violence",
  "Self-harm",
  "Scam/Fraud",
  "Illegal Content",
  "Sexually Explicit Content",
  "Other",
];

export default function ReportDialog({
  open,
  onClose,
  reportedEntityId,
  entityType,
}) {

  useEffect(() => {
    if (open) {
      document.body.style.position = "fixed";
    } else {
      document.body.style.position = "";
    }

    return () => {
      document.body.style.position = "";
    };
  }, [open]);

  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");

  if (!open) return null;              // nothing to render

  const handleReport = async () => {
    if (!category || !description.trim()) {
      alert("Please select a category and provide details.");
      return;
    }
    try {
      await axiosInstance.post("/reports", {
        entity_id: reportedEntityId,
        entity_type: entityType,
        category,
        description,
      });
      alert("Your report has been submitted.");
      onClose();
      setCategory("");
      setDescription("");
    } catch (error) {
      console.error("Error reporting:", error);
      alert("Failed to submit report.");
    }
  };

  // ----------  Portal ----------
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
      onClick={(e) => {
        e.stopPropagation();
        onClose();
      }}
    >
      <div
        className="relative w-11/12 max-w-md rounded-xl bg-white p-6 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="mb-4 text-center text-xl font-bold text-black">
          Report {entityType}
        </h2>

        {/* form */}
        <div className="flex flex-col gap-4">
          <Select
            fullWidth
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            displayEmpty
            variant="outlined"
            MenuProps={{ disablePortal: true }}
            sx={{
              backgroundColor: "#f3f3f3",
              borderRadius: "8px",
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#f3f3f3" },
            }}
          >
            <MenuItem value="" disabled>
              Select a category
            </MenuItem>
            {REPORT_CATEGORIES.map((cat) => (
              <MenuItem key={cat} value={cat}>
                {cat}
              </MenuItem>
            ))}
          </Select>

          <TextField
            label="Details"
            placeholder="Describe the issue..."
            multiline
            rows={4}
            fullWidth
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            margin="normal"
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                backgroundColor: "#f3f3f3",
              },
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#f3f3f3" },
            }}
          />
        </div>

        {/* actions */}
        <div className="mt-6 flex justify-between">
          <Button
            onClick={onClose}
            sx={{
              backgroundColor: "#f5f5f5",
              color: "#333",
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": { backgroundColor: "#e0e0e0" },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleReport}
            sx={{
              backgroundColor: "#d32f2f",
              color: "#fff",
              textTransform: "none",
              borderRadius: "8px",
              "&:hover": { backgroundColor: "#b71c1c" },
            }}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
}
